import React from "react";

const EmailVerification = () => {
  return <div>EmailVerification</div>;
};

export default EmailVerification;
